import { BrowserRouter } from 'react-router-dom';

import { AppRoutes } from './routes';
import { IInformacoesDeUsuario, PerfilDeUsuarioProvider } from './shared/contexts/PerfilDeUsuarioContext';
import core from '@gvdasa/gv-core';
import { Environment } from './shared/environment';
import {GVComponentsProvider, Theme} from '@gvdasa/react-components';


export interface IAppProps {
  theme: Theme;
  informacoesDeUsuario: IInformacoesDeUsuario
}

if (Environment.APP_INSIGHTS_CONNECTION_STRING !== '') {
  core.GVObservable(Environment.APP_INSIGHTS_CONNECTION_STRING);
}

export const App = ({ theme, informacoesDeUsuario }: IAppProps) => {

  return (
    <GVComponentsProvider theme={theme}>
        <PerfilDeUsuarioProvider informacoesDeUsuario={informacoesDeUsuario}>
          <BrowserRouter basename='/permissoes'>
            <AppRoutes />
        </BrowserRouter>
      </PerfilDeUsuarioProvider>
    </GVComponentsProvider>
  );
};
